import { createContext, useContext } from 'react';
import { ScreenThemeStateContextType } from './ScreenThemeStateContext';

export const eventScreenThemeContext =
  createContext<ScreenThemeStateContextType | null>(null);

export function useScreenTheme() {
  const context = useContext(eventScreenThemeContext);
  if (!context) {
    throw new Error(
      'useScreenTheme must be used within EventScreenThemeProvider',
    );
  }
  return context;
}
